import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link } from 'react-router-dom'
import { Markup } from 'interweave';
import InfiniteScroll from "react-infinite-scroller";
import { ReactSession } from 'react-client-session';
import {Helmet} from "react-helmet";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import '../Dashboard.css';
import classes from "./Musics.module.css";
import styles from '../Dashboard.module.css';

import Header from "../Header/Header";
import Sidebar from "../Sidebar/Sidebar";
import Footer from "../../Footer/Footer";
import Spinner from "../../Global/Spinner";
import EmptyContent from '../../Global/EmptyContent'

import noThumb from "../../../images/no-thumb.jpg";

function Musics() {
    const [videos, setVideos] = useState([]);
    const [hasMore, sethasMore] = useState(true);
    const [page, setpage] = useState(2);
    const [loading, setLoading] = useState(false);
    ReactSession.setStoreType("localStorage");

    const logged_user = ReactSession.get("logged_user");

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const config = {
        params: {
            uid: logged_user,
            user_id: logged_user,
            pname: 'wesharez',
            limit: 10
        },
        headers: {
            "Content-Type": "multipart/form-data",
        }
    }

    useEffect(() => {
        axios.post(`${process.env.REACT_APP_API_URL}/api/user/musics.php?page=1`, null, config)
        .then(res => {
            setVideos(res.data);
            res.data.length < config.params.limit ? sethasMore(false) : sethasMore(true);

            setLoading(true);
        }).catch(err => {
            console.log(err);
        })
    }, [])

    const loadMore = () => {
        loading && hasMore && axios.post(`${process.env.REACT_APP_API_URL}/api/user/musics.php?page=${page}`, null, config)
        .then(res => {
            if(res.data.message !== 'No musics found') {
                setVideos([...videos, ...res.data]);
                setpage(page + 1);
        
                res.data.length < config.params.limit ? sethasMore(false) : sethasMore(true);
            }else {
                sethasMore(false);
            }
        }).catch(err => {
            console.log(err);
        })
    }

    const handleDelete = (id) => {
        const video = document.getElementById(`video_${id}`);
        if(video) {
            if(window.confirm("Are you sure you want to delete this music?")) {
                const toast_id = toast.loading("Please wait...");
                axios.post(`${process.env.REACT_APP_API_URL}/api/user/delete-video.php`,
                    {  
                        uid: logged_user,
                        vid: id,
                        action: 'delete'
                    }, {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        }
                    }
                ).then(res => {
                    if(res.data.status === 'success') {
                        video.remove();
                        toast.update(toast_id, {render: "Music deleted successfully.", autoClose: 5000, type: "success", isLoading: false});
                    }else {
                        toast.update(toast_id, {render: "Something went wrong!!", autoClose: 5000, type: "error", isLoading: false});
                    }
                }).catch(err => {
                    console.log(err);
                })
            }
        }
    }

    const toggleCheckAll = () => {
        const checkboxes = document.querySelectorAll('#checkrow');
        const checkall = document.querySelector('#check-all');

        if(checkall.checked) {
            checkboxes.forEach((cb) => {
                cb.checked = true;
            });
        }else {
            checkboxes.forEach((cb) => {
                cb.checked = false;
            });
        }
    }

    const deleteAll = () => {
        if(window.confirm("Are you sure you want to delete all selected music?")) {
            const toast_id = toast.loading("Please wait...");
            let data = new FormData();
            data.append('uid', logged_user);
            var array = [];

            var checkboxes = document.querySelectorAll('#checkrow');
            for (var i = 0; i < checkboxes.length; i++) {
                if(checkboxes[i].checked){
                    data.append('checkRow[]', checkboxes[i].value)
                    array.push(checkboxes[i].value);
                }
            }

            console.log(array);

            axios.post(`${process.env.REACT_APP_API_URL}/api/user/delete-video.php`, data , {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    }
                }).then(res => {
                    // console.log(res.data);
                    if(res.data.status === 'success') {
                        array.forEach(item => {document.getElementById(`video_${item}`).remove();});
                        toast.update(toast_id, {render: "Videos deleted successfully.", autoClose: 5000, type: "success", isLoading: false});
                    }else {
                        toast.update(toast_id, {render: "Something went wrong!", autoClose: 5000, type: "error", isLoading: false});
                    }
                }).catch(err => {
                    console.log(err);
                });
        }
    }

    return (
        <>
            <Helmet>
                <title>Musics</title>
            </Helmet>
            <div className="container_wrapper">
                <Header />
                <div className={`${styles.main} main`}>
                    <ToastContainer />
                    <Sidebar active="music" />
                    <div className={styles.main_content}>
                        <div className={styles.content_body}>
                            <div className={`${styles.title} mb-4`}>
                                <h5><i className="fa-solid fa-film"></i> Music</h5>
                            </div>
                            <div className={styles.card}>
                                <div className={`${styles.item_in_list} ${styles.list_header}`}>
                                    <div className="checkbox">
                                        <input type="checkbox" name="checkRows" id="check-all" onClick={() => toggleCheckAll()} />
                                        <label></label> Select all
                                    </div>
                                    <div className={styles.delete_btn}>
                                        <button className="btn btn-danger" type="submit" onClick={() => deleteAll()}>
                                            <i className="fa-regular fa-trash-can"></i> Selected
                                        </button>
                                    </div>
                                </div>
                                <div className="card-body">
                                    <div className={styles.content_items}>
                                        {
                                            videos && videos.map ? <InfiniteScroll
                                                pageStart={0}
                                                loadMore={loadMore}
                                                hasMore={hasMore}
                                                loader={<div className="loader my-4" key={0} align="center">{<Spinner />}</div>}
                                                className='row'
                                            >
                                                {
                                                    videos.map((video, index) => {
                                                        let thumb = null;
                                                        if(video.thumb.includes('storage/media/thumbs/')) {
                                                            thumb = `${process.env.REACT_APP_API_URL}/${video.thumb}`;
                                                        }else {
                                                            thumb = video.thumb;
                                                        }
                                                        return (
                                                            <div id={`video_${video.id}`} className={styles.item_in_list} key={index}>
                                                                <div className={styles.segment}>
                                                                    <div className={styles.checkbox}>
                                                                        <input id="checkrow" type="checkbox" name="checkRow[]" defaultValue={video.id} />
                                                                        <label></label>
                                                                    </div>
                                                                </div>
                                                                <div className={styles.segment}>
                                                                    <div className={styles.left}>
                                                                        <Link className="" target="_blank" rel="noreferrer" to={false} title="View">
                                                                            <img src={thumb} onError={e => {e.target.src = noThumb}} alt="thumb" />
                                                                        </Link>
                                                                    </div>
                                                                    <div className={styles.right}>
                                                                        <Link className={styles.content_title} target="_blank" rel="noreferrer" to={false} title="View">
                                                                            <strong><Markup content={video.title} /></strong>
                                                                        </Link>
                                                                        <div className={`${styles.btn_group} btn-group`}>
                                                                            <Link className="btn btn-primary" to={`/dashboard/edit-video/${video.id}`} title="Edit">
                                                                                <i className="fa-solid fa-pen"></i>
                                                                            </Link>
                                                                            <Link className="btn btn-danger" to={false} title="Unpublish" onClick={() => handleDelete(video.id)}>
                                                                                <i className="fa-regular fa-trash-can"></i>
                                                                            </Link>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )
                                                    })
                                                }
                                            </InfiniteScroll>
                                            : <EmptyContent />
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    <Footer />
                    </div>
                </div>
            </div>
        </>
    );
}

export default Musics;